import { ROLE } from "../../../const/role";

export const checkRoleAdmin = {
    methods: {
        checkRoleAdmin(loginUser) {
            const isAdmin = (loginUser && loginUser.admin === ROLE.ROLE_USER_ADMIN);
            const isEditSelf = loginUser.id === this.user.id;
            this.isAdmin = isAdmin;
            this.isAllowEdit = isAdmin || isEditSelf;
        },
    }
};